import React, { useContext, useEffect } from "react";
import { AuthContext } from "./context/AuthContext";

import Router from "./routes";
import AlertSuccess from "./shared/AlertBox/AlertSuccess/AlertSuccess";
import BackdropHan from "./shared/Backdrop/Backdrop";
import ToastMessage from "./shared/ToastMessage/ToastMessage";

function App() {
  const { isLoading } = useContext(AuthContext)
  useEffect(() => {
    return () => {
      document.addEventListener('contextmenu', (e) => {
        e.preventDefault()
      });
    };
  }, []);

  return (
    <div>
      <Router />
      <ToastMessage />
      <BackdropHan open={isLoading} />
      <AlertSuccess />

      {/* <Routes>
        <Route path="" element={<Frontlayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/how-to-apply" element={<Instructions />} />
          <Route path="/" element={<ExamForm />} />
          <Route path="/important-dates" element={<ImportantDates />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/basic-info" element={<BasicInfoModal />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/scroll-table" element={<ScrollableTable />} />
        </Route>
      </Routes> */}
    </div>
  );
}

export default App;
